import { render, staticRenderFns } from "./News.vue?vue&type=template&id=7d9eb38f&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.vue?vue&type=style&index=0&id=7d9eb38f&prod&lang=scss"
import style1 from "./News.vue?vue&type=style&index=1&id=7d9eb38f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9eb38f",
  null
  
)

export default component.exports